import React from 'react';

function Footer() {
    return <footer>elmo {new Date().getFullYear()}</footer>;
}

export default Footer;
